export default () => {
    const pirceItems = document.querySelector("*[price-page]");
    if (pirceItems == null)
        return;
    import(/* webpackChunkName: "price switch" */ "../classes/priceSwitchClass")
        .then(({ default: PriceSwitch }) => {
        new PriceSwitch();
    })
        .catch(() => "An error with price switch occurred");
};
